import {
  fetchPopupRead,
  fetchPopupList,
} from '../services/api';

export default {
  namespace: 'global',

  state: {
    collapsed: false,
  },

  effects: {
    *fetchPopupRead({ payload, callback }, { call }) {
      const response = yield call(fetchPopupRead, payload);
      if (callback) callback(response);
    },
    *fetchPopupList({ payload, callback }, { call }) {
      const response = yield call(fetchPopupList, payload);
      if (callback) callback(response);
    },
  },

  reducers: {
    changeLayoutCollapsed(state, { payload }) {
      return {
        ...state,
        collapsed: payload,
      };
    },
  },

  subscriptions: {
    setup({ history }) {
      // Subscribe history(url) change, trigger `load` action if pathname is `/`
      return history.listen(({ pathname, search }) => {
        if (typeof window.ga !== 'undefined') {
          window.ga('send', 'pageview', pathname + search);
        }
      });
    },
  },
};
